import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white pt-10 pb-6 w-full">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

                {/* Logo + About */}
                <div>
                    <h2 className="text-2xl font-bold mb-3 text-yellow-400">AXS Enterprises</h2>
                    <p className="text-sm text-gray-300">
                        We are manufacturers, exporters, and traders of premium dry fruits, spices, garam masala, rice, and more — delivering quality across the globe.
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h3 className="text-lg font-semibold mb-3 text-yellow-400">Quick Links</h3>
                    <ul className="space-y-2 text-sm text-gray-300">
                        <li><a href="/" className="hover:text-yellow-300">Home</a></li>
                        <li><a href="/products" className="hover:text-yellow-300">Products</a></li>
                        <li><a href="/about" className="hover:text-yellow-300">About Us</a></li>
                        <li><a href="/contact" className="hover:text-yellow-300">Contact</a></li>
                    </ul>
                </div>

                {/* Contact Info */}
                <div>
                    <h3 className="text-lg font-semibold mb-3 text-yellow-400">Contact Us</h3>
                    <ul className="space-y-2 text-sm text-gray-300">
                        <li className="flex items-center gap-2">
                            <FaPhoneAlt className="text-yellow-400" /> +91 99904 04922
                        </li>
                        <li className="flex items-center gap-2">
                            <FaEnvelope className="text-yellow-400" /> info@axsenterprises.com
                        </li>
                        <li className="flex items-center gap-2">
                            <FaMapMarkerAlt className="text-yellow-400" /> C-5A Ramdutt Enclave Beside Lal Mandir, India
                        </li>
                    </ul>
                </div>

                {/* Social Media */}
                <div>
                    <h3 className="text-lg font-semibold mb-3 text-yellow-400">Follow Us</h3>
                    <div className="flex gap-4">
                        <a href="#" className="hover:text-yellow-300"><FaFacebook size={20} /></a>
                        <a href="#" className="hover:text-yellow-300"><FaInstagram size={20} /></a>
                        <a href="#" className="hover:text-yellow-300"><FaTwitter size={20} /></a>
                    </div>
                </div>
            </div>

            {/* Bottom Strip */}
            <div className="border-t border-gray-700 mt-10 pt-4 text-center text-sm text-gray-400 px-4">
                © {new Date().getFullYear()} AXS Enterprises. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
